import { inject, signal, Service } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { Api } from '@api/api';
import { getMaintenanceInfo } from '@api/functions';
import type { MaintenanceInfoDto } from '@api/models';

@Service()
export class MaintenanceService {
  private api = inject(Api);

  isMaintenanceInProgress = signal<boolean>(false);
  maintenanceEndTime = signal<Date | null>(null);

  fetchAndSetMaintenanceInfo(): Observable<boolean> {
    return this.api.invoke(getMaintenanceInfo)
      .pipe(
        tap(response => this.setMaintenanceInfo(response)),
        map(() => true),
        catchError(() => of(true)),
      );
  }

  setMaintenanceInfo(info: MaintenanceInfoDto) {
    this.isMaintenanceInProgress.set(info.isMaintenanceInProgress);
    this.maintenanceEndTime.set(info.maintenanceEndTime ? new Date(info.maintenanceEndTime) : null);
  }
}
